exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device[data-v-0613b2d8] {\n  height: 500px;\n}\n.device .btn[data-v-0613b2d8] {\n    cursor: pointer;\n}\n.device.active[data-v-0613b2d8] {\n    color: #f2bc53;\n}\n.device.active .svg > path[data-v-0613b2d8] {\n      fill: #f2bc53;\n}\n.device .device-name[data-v-0613b2d8] {\n    margin: 32px 0;\n    font-size: 16px;\n}\n@media screen and (max-height: 750px) {\n.device .device[data-v-0613b2d8] {\n      height: 316px;\n}\n}\n", ""]);

// exports
